<template>
  <div id="language">
    <!-- topline -->
    <app-top-line></app-top-line>
    <!-- navigate -->
    <app-navigation></app-navigation>
    <!-- ROUTER COMPONENT VIEW -->
    <div class="viewpage">
      <router-view/>
    </div>
    <!-- MUSIC PLAYER -->
    <app-music-player></app-music-player>
    <!-- footer -->
    <div class="rss">
      <!-- 1 -->
      <div class="box__rss">
        <router-link :to="`/${lng}/updates`">{{ t.update }}</router-link>
      </div>
      <!-- 2 -->
      <div class="box__rss tool">
        <a v-if="lng=='tr'" href="javascript:;" @click="modal = 'faq'">SSS</a>
        <a href="javascript:;" @click="modal = 'term_of_use'">{{ t.termOfuse }}</a>
      </div>
      <!-- 3 -->
      <div class="box__rss">
        <p>{{`${t.copyright1}${new Date().getFullYear()}${t.copyright2}`}}</p>
        <p class="poweredBy">
          powered by
          <a href="http://diginity.com/" target="_blank">
            <img src="/assets/diginity.svg" alt>
          </a>
        </p>
      </div>
    </div>
    <!-- term of use | SSS modal component -->
    <transition name="fade">
      <app-term-of-use v-if="modal" :type="modal" @closed="modal = $event"></app-term-of-use>
    </transition>
  </div>
</template>

<script>
import TopLine from "./shared/TopLine.vue";
import Navigation from "./shared/Navigation.vue";
import MusicPlayer from "./shared/MusicPlayer.vue";
import TermOfUseVue from "./shared/TermOfUse.vue";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      modal: undefined
    };
  },
  computed: {
    ...mapGetters(["t", "lng"])
  },

  watch: {
    "$route.params.lang"(newValue, oldValue) {
      // watching URL params lang
      // 'Actions.js' see => 'language'
      this.$store.dispatch("language", this.$route.params.lang);
    }
  },
  components: {
    appTopLine: TopLine,
    appNavigation: Navigation,
    appMusicPlayer: MusicPlayer,
    appTermOfUse: TermOfUseVue
  }
};
</script>

<style lang="scss" scoped>
</style>
